const CORE_APP_ROUTE_PATHS = [
  "/agents",
  "/asset",
  "/crypto",
  "/dashboard",
  "/debug",
  "/build",
  "/explore",
  "/explore-all",
  "/investing-account",
  "/onboarding",
  "/portfolio",
  "/referrals",
  "/rewards",
  "/settings",
  "/stocks",
  "/strategy",
  "/template",
  "/user",
] as const;

const PUBLIC_PAGE_VIEW_TRANSITION_TYPE = "public-page";

interface PageViewTransitionLocation {
  pathname: string;
}

interface PageViewTransitionLocationChange {
  fromLocation?: PageViewTransitionLocation;
  pathChanged: boolean;
  toLocation: PageViewTransitionLocation;
}

function isPathInRouteSection(pathname: string, sectionPath: string): boolean {
  return pathname === sectionPath || pathname.startsWith(`${sectionPath}/`);
}

export function isCoreAppPathname(pathname: string): boolean {
  return CORE_APP_ROUTE_PATHS.some((sectionPath) =>
    isPathInRouteSection(pathname, sectionPath),
  );
}

export function resolvePageViewTransitionTypes(
  locationChange: PageViewTransitionLocationChange,
): Array<string> | false {
  if (!locationChange.pathChanged || !locationChange.fromLocation) {
    return false;
  }

  const fromIsCoreApp = isCoreAppPathname(locationChange.fromLocation.pathname);
  const toIsCoreApp = isCoreAppPathname(locationChange.toLocation.pathname);

  if (fromIsCoreApp && toIsCoreApp) {
    return false;
  }

  return [PUBLIC_PAGE_VIEW_TRANSITION_TYPE];
}
